export default __webpack_public_path__ + "static/media/39.79b6fe60.jpg";